<template>
<div id="consulta_adjuntos_pedimentos">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>

    <v-container grid-list-md text-xs-center>

        <v-flex xs12>
            <base-material-card color="primary" icon="library_books" title="Facturas en Tránsito" class="elevation-1 px-5 py-3">
                <br />
                <v-tabs grow style="margin-bottom: 30px">
                    <v-tabs-slider color="primary"></v-tabs-slider>
                    <v-tab :key="'in-file'">Cargar Archivo</v-tab>
                    <v-tab :key="'in-view'">Vista Previa</v-tab>
                    <v-tab :key="'in-reporte'">Reporte Facturas Detallado</v-tab>
                    <v-tab :key="'in-reporte-comercio'">Reporte Facturas Comercio Exterior</v-tab>
                    <v-tab :key="'descarga'">Descargar Expediente</v-tab>
                    <v-tab-item :key="'in-file'">

                        <v-card class="elevation-1 px-5 py-3">

                            <v-card-text>
                                <v-card-text>
                                    <v-form ref="form" lazy-validation>
                                        <v-container grid-list-md>
                                            <v-layout wrap>
                                                <p class="text-justify">
                                                    <v-icon color="indigo">info</v-icon>
                                                    <strong>El archivo ZIP debe ser nombrado facturas_en_transito.zip </strong>
                                                </p>

                                                <v-flex xs12>
                                                    <v-text-field label="Selecciona el archivo ZIP" @click='pickFile' v-model='name_file' :rules="[rules.required]" :readonly="true" prepend-icon='attach_file'></v-text-field>
                                                    <input type="file" style="display: none" ref="file_input" accept=".zip" @change="onFilePicked">
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-form>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>

                                    <v-btn@click.native="modal=false; reset();">
                                        <v-icon>cancel</v-icon> Cancelar</v-btn>
                                        <v-btn v-if="false" color="success">
                                            <v-icon>done</v-icon>Guardar
                                        </v-btn>
                                </v-card-actions>
                            </v-card-text>
                        </v-card>

                    </v-tab-item>
                    <v-tab-item :key="'in-view'">
                        <v-card-text>
                            <v-card-title>
                                <span class="headline"></span>
                            </v-card-title>
                            <v-form ref="form1" lazy-validation>
                                <v-container grid-list-md text-xs-center>

                                    <v-row row wrap>
                                        <v-col sm="12" md="4" lg="4">
                                            <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="
                                                                        model.fecha_de = parseDate(model.fecha_de)
                                                                        " v-mask="'####-##-##'" :rules="[
                                                                        verificaRequeridos,
                                                                        validaDias,
                                                                        validaFecha,
                                                                        ]">
                                                    </v-text-field>
                                                </template>

                                                <v-date-picker v-model="model.fecha_de" color="secondary" landscape scrollable locale="es-mx" @input="menu1 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" large @click="menu1 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col sm="12" md="4" lg="4">
                                            <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a = parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[
                                                            verificaRequeridos,
                                                            validaDias,
                                                            validaFecha,
                                                            ]"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="model.fecha_a" color="secondary" landscape scrollable locale="es-mx" @input="menu2 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" large @click="menu2 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>

                                        <v-col sm="12" md="2" lg="2">
                                         <v-radio-group v-model="model.fecha_factura" row>
                                                <v-radio label="Fecha de Carga" :value="false" ></v-radio>
                                                <v-radio label="Fecha de Emisión" :value="true" ></v-radio>
                                            </v-radio-group>
                                        </v-col>
                                         <v-col sm="12" md="2" lg="2">
                                             &nbsp;
                                          </v-col>
                                    </v-row>
                                    <v-row row wrap>
                                        <v-col sm="12" md="6" lg="6">
                                            <v-autocomplete :hide-no-data="true" :items="tiposComprobante" v-model="model.tipo_comprobante" clearable
                                                @change="model.rfc_filtro=''" item-text="nombre" item-value="nombre" label="Seleccione Tipo de Comprobante" ></v-autocomplete>
                                        </v-col>
                                        <v-col sm="12" md="2" lg="2">
                                            <v-btn icon title="Listado UUID" @click="dialog1 = !dialog1; tipo_reporte_seleccionado=1;" v-tippy>
                                                <v-icon colorHover="secondary" size="48">mdi-clipboard-list-outline</v-icon>
                                            </v-btn>
                                        </v-col>
                                        <v-col sm="12" md="2" lg="2">
                                             <v-btn rounded color="success" @click="get_data_view()" :loading="loading">
                                                <v-icon>done</v-icon>Vista Previa
                                            </v-btn>
                                          </v-col>
                                          <v-col sm="12" md="2" lg="2">
                                             &nbsp;
                                          </v-col>
                                    </v-row>
                                    <v-row row wrap v-if="['Ingreso','Egreso'].includes(model.tipo_comprobante)">
                                        <v-col sm="12" md="6" lg="6">
                                            <v-text-field :label="model.tipo_comprobante=='Ingreso'?'Filtrar por RFC Receptor':'Filtrar por RFC Emisor'" v-model='model.rfc_filtro' clearable 
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                </v-container>
                            </v-form>
                            <v-card>
                                <v-card-actions v-if="data_resumen.length>0">
                                    <v-btn v-if="to_download.length > 0" rounded color="info" @click="download_files" :loading="loading">
                                        <v-icon>done</v-icon>Descargar Seleccionados
                                    </v-btn>
                                    <v-btn v-if="data_resumen.length>0" small  dark color="red" @click="deleteLista()" title="Eliminar Todos" v-tippy>
                                                <v-icon>delete</v-icon>Eliminar Todos
                                            </v-btn>
                                    <v-spacer></v-spacer>
                                    
                                    <exportar-excel :data="datafiltered" :exportFields="data_resumen_excel" name="Resumen_Facturas_Transito.xlsx">
                                        <v-btn dark small color="success" title="Exportar Resumen" v-tippy>
                                            <v-icon dark>get_app</v-icon> Exportar a Excel
                                        </v-btn>
                                    </exportar-excel>

                                </v-card-actions>
                                <v-card-text>

                                    <v-client-table id="vuetabledetalle" ref="vuetabledetalle" :data="data_resumen" :columns="columns_resumen" :options="options_resumen" class="elevation-2 pa-2 scroll-table">
                                        <template slot="noResults">
                                            <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                                        </template>
                                        <div slot="filter__id">
                                            <input type="checkbox" class="form-control check-all" v-model='allChecked' @change="check_all()">
                                        </div>

                                        <template slot="id" slot-scope="props">
                                            <div style="display:flex; justify-content:center;">
                                                <input :id="model.rfc + '/' + props.row.folder + '/' + props.row.filename" type="checkbox" v-model="to_download" :value="model.rfc + '/' + props.row.folder + '/' + props.row.filename" />
                                            </div>

                                        </template>
                                          <template slot="tipo_documento" slot-scope="props">
                                            <div style="display:flex; justify-content:center;">
                                               {{props.row.tipo_documento.substring(0, 25)}}
                                            </div>

                                        </template>
                                         <template slot="importe" slot-scope="props">
                                            <div style="display:flex; justify-content:right;">
                                               {{props.row.importe}}
                                            </div>

                                        </template>


                                        <template slot="actions_view" slot-scope="props">
                                            <v-btn x-small fab dark color="purple" 
                                                v-if="props.row.key_pdf==null || props.row.key_pdf==''"
                                                @click="verFacturaProforma(props.row.rfc, props.row.filename)" 
                                                title="Factura Proforma" v-tippy>
                                                <v-icon>receipt</v-icon>
                                            </v-btn>
                                            <v-btn x-small fab dark color="purple" 
                                                v-if="props.row.key_pdf!=null && props.row.key_pdf!=''"
                                                @click="downloadProforma(props.row.key_pdf)" 
                                                title="Factura Proforma2" v-tippy>
                                                <v-icon>receipt</v-icon>
                                            </v-btn>&nbsp;
                                            <v-btn x-small fab dark color="secondary" @click="downloadFile(props.row)" title="Descargar" v-tippy>
                                                <v-icon>mdi-download</v-icon>
                                            </v-btn>&nbsp;
                                            <v-btn x-small fab dark color="red" @click="deleteFile(props.row.id)" title="Eliminar" v-tippy>
                                                <v-icon>delete</v-icon>
                                            </v-btn>
                                        </template>
                                    </v-client-table>
                                </v-card-text>
                            </v-card>
                        </v-card-text>
                    </v-tab-item>
                    <v-tab-item :key="'in-reporte'">
                        <v-card-text>
                            <v-card-title>
                                <span class="headline"></span>
                            </v-card-title>
                            <v-form ref="formreporte" lazy-validation>
                                <v-container grid-list-md text-xs-center>

                                    <v-row row wrap>
                                        <v-col sm="12" md="4" lg="4">
                                            <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="
                                                                        model.fecha_de = parseDate(model.fecha_de)
                                                                        " v-mask="'####-##-##'" :rules="[
                                                                        rules.required,
                                                                        validaDias,
                                                                        validaFecha,
                                                                        $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)
                                                                        ]">
                                                    </v-text-field>
                                                </template>

                                                <v-date-picker v-model="model.fecha_de" color="secondary" landscape scrollable locale="es-mx" @input="menu3 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" large @click="menu3 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col sm="12" md="4" lg="4">
                                            <v-menu ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a = parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[
                                                            rules.required,
                                                            validaDias,
                                                            validaFecha,
                                                            $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)
                                                            ]"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="model.fecha_a" color="secondary" landscape scrollable locale="es-mx" @input="menu4 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" large @click="menu4 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                         <v-col sm="12" md="2" lg="2">
                                          <v-radio-group v-model="model.fecha_factura" row>
                                                <v-radio label="Fecha de Carga" :value="false" ></v-radio>
                                                <v-radio label="Fecha de Emisión" :value="true" ></v-radio>
                                            </v-radio-group>
                                          </v-col>
                                         <v-col sm="12" md="2" lg="2">
                                          &nbsp;
                                          </v-col>
                                    </v-row>
                                    <v-row row wrap>
                                        <v-col sm="12" md="6" lg="6">
                                            <v-autocomplete :hide-no-data="true" :items="tiposComprobante" v-model="model.tipo_comprobante" clearable
                                                item-text="nombre" item-value="nombre" label="Seleccione Tipo de Comprobante" ></v-autocomplete>
                                        </v-col>
                                        <v-col sm="12" md="2" lg="2">
                                            <v-btn icon title="Listado UUID" @click="dialog1 = !dialog1; tipo_reporte_seleccionado=2;" v-tippy>
                                                <v-icon colorHover="secondary" size="48">mdi-clipboard-list-outline</v-icon>
                                            </v-btn>
                                        </v-col>
                                        <v-col sm="12" md="2" lg="2">
                                            <v-btn rounded color="primary" @click="generar_reporte_sqs()" :loading="loadingReporte">
                                                <v-icon>done</v-icon>Generar Reporte
                                            </v-btn>
                                          </v-col>
                                          <v-col sm="12" md="2" lg="2">
                                             &nbsp;
                                          </v-col>
                                    </v-row>
                                    <v-row row wrap v-if="['Ingreso','Egreso'].includes(model.tipo_comprobante)">
                                        <v-col sm="12" md="6" lg="6">
                                            <v-text-field :label="model.tipo_comprobante=='Ingreso'?'Filtrar por RFC Receptor':'Filtrar por RFC Emisor'" v-model='model.rfc_filtro' clearable 
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                </v-container>
                            </v-form>

                            <v-card>
                                <v-card-text>

                                    <v-refresh-button :funcion="cargarReportesDS" />
                                    <v-client-table ref="vuetable" :data="datos" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                        <template slot="noResults" >
                                            <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                        </template>

                                        <template slot="actions" slot-scope="props" >
                                            <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadReporte(props.row.filename)" >
                                                <v-icon dark>get_app</v-icon>
                                            </v-btn>
                                            <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                                                <v-icon dark>delete</v-icon>
                                            </v-btn>
                                        </template>
                                    </v-client-table>
                                </v-card-text>
                            </v-card>
                        </v-card-text>
                    </v-tab-item>
                    <v-tab-item :key="'in-reporte-comercio'">
                        <v-card-text>
                            <v-card-title>
                                <span class="headline"></span>
                            </v-card-title>
                            <v-form ref="formreportecomercio" lazy-validation>
                                <v-container grid-list-md text-xs-center>

                                    <v-row row wrap>
                                        <v-col sm="12" md="4" lg="4">
                                            <v-menu ref="menu5" v-model="menu5" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="
                                                                        model.fecha_de = parseDate(model.fecha_de)
                                                                        " v-mask="'####-##-##'" :rules="[
                                                                        rules.required,
                                                                        validaDias,
                                                                        validaFecha,
                                                                        $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)
                                                                        ]">
                                                    </v-text-field>
                                                </template>

                                                <v-date-picker v-model="model.fecha_de" color="secondary" landscape scrollable locale="es-mx" @input="menu5 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" large @click="menu5 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col sm="12" md="4" lg="4">
                                            <v-menu ref="menu6" v-model="menu6" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a = parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[
                                                            rules.required,
                                                            validaDias,
                                                            validaFecha,
                                                            $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)
                                                            ]"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="model.fecha_a" color="secondary" landscape scrollable locale="es-mx" @input="menu6 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" large @click="menu6 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                         <v-col sm="12" md="2" lg="2">
                                          <v-radio-group v-model="model.fecha_factura" row>
                                                <v-radio label="Fecha de Carga" :value="false" ></v-radio>
                                                <v-radio label="Fecha de Emisión" :value="true" ></v-radio>
                                            </v-radio-group>
                                          </v-col>
                                         <v-col sm="12" md="2" lg="2">
                                          &nbsp;
                                          </v-col>
                                    </v-row>
                                    <v-row row wrap>
                                        <v-col sm="12" md="6" lg="6">
                                            <v-autocomplete :hide-no-data="true" :items="tiposComprobante" v-model="model.tipo_comprobante" clearable
                                                item-text="nombre" item-value="nombre" label="Seleccione Tipo de Comprobante" ></v-autocomplete>
                                        </v-col>
                                        <v-col sm="12" md="2" lg="2">
                                            <v-btn icon title="Listado UUID" @click="dialog1 = !dialog1; tipo_reporte_seleccionado=3;" v-tippy>
                                                <v-icon colorHover="secondary" size="48">mdi-clipboard-list-outline</v-icon>
                                            </v-btn>
                                        </v-col>
                                        <v-col sm="12" md="2" lg="2">
                                            <v-btn rounded color="primary" @click="generar_reporte_sqs_comercio()" :loading="loadingReporte">
                                                <v-icon>done</v-icon>Generar Reporte
                                            </v-btn>
                                          </v-col>
                                          <v-col sm="12" md="2" lg="2">
                                             &nbsp;
                                          </v-col>
                                    </v-row>
                                    <v-row row wrap v-if="['Ingreso','Egreso'].includes(model.tipo_comprobante)">
                                        <v-col sm="12" md="6" lg="6">
                                            <v-text-field :label="model.tipo_comprobante=='Ingreso'?'Filtrar por RFC Receptor':'Filtrar por RFC Emisor'" v-model='model.rfc_filtro' clearable 
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                </v-container>
                            </v-form>

                            <v-card>
                                <v-card-text>

                                    <v-refresh-button :funcion="cargarReportesComercio" />
                                    <v-client-table ref="vuetable" :data="datos_comercio" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                        <template slot="noResults" >
                                            <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                        </template>

                                        <template slot="actions" slot-scope="props" >
                                            <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadReporte(props.row.filename)" >
                                                <v-icon dark>get_app</v-icon>
                                            </v-btn>
                                            <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                                                <v-icon dark>delete</v-icon>
                                            </v-btn>
                                        </template>
                                    </v-client-table>
                                </v-card-text>
                            </v-card>
                        </v-card-text>
                    </v-tab-item>
                    <v-tab-item :key="'descarga'">
                        <v-card-text>
                            <v-card-title>
                                <span class="headline"></span>
                            </v-card-title>
                            <v-form ref="form_expediente" lazy-validation>
                                <v-container grid-list-md text-xs-center>

                                    <v-row row wrap>
                                        <v-col sm="12" md="4" lg="4">
                                            <v-menu ref="menu10" v-model="menu10" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="
                                                                        model.fecha_de = parseDate(model.fecha_de)
                                                                        " v-mask="'####-##-##'" :rules="[
                                                                        verificaRequeridos,
                                                                        validaDias,
                                                                        validaFecha,
                                                                        ]">
                                                    </v-text-field>
                                                </template>
    
                                                <v-date-picker v-model="model.fecha_de" color="secondary" landscape scrollable locale="es-mx" @input="menu10 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" large @click="menu10 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col sm="12" md="4" lg="4">
                                            <v-menu ref="menu20" v-model="menu20" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a = parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[
                                                            verificaRequeridos,
                                                            validaDias,
                                                            validaFecha,
                                                            ]"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="model.fecha_a" color="secondary" landscape scrollable locale="es-mx" @input="menu20 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" large @click="menu20 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>

                                        <v-col sm="12" md="2" lg="2">
                                         <v-radio-group v-model="model.fecha_factura" row>
                                                <v-radio label="Fecha de Carga" :value="false" ></v-radio>
                                                <v-radio label="Fecha de Emisión" :value="true" ></v-radio>
                                            </v-radio-group>
                                        </v-col>
                                         <v-col sm="12" md="2" lg="2">
                                             &nbsp;
                                          </v-col>
                                    </v-row>
                                    <v-row row wrap>
                                        <v-col sm="12" md="6" lg="6">
                                            <v-autocomplete :hide-no-data="true" :items="tiposComprobante" v-model="model.tipo_comprobante" clearable
                                                item-text="nombre" item-value="nombre" label="Seleccione Tipo de Comprobante" ></v-autocomplete>
                                        </v-col>
                                        <v-col sm="12" md="2" lg="2">
                                            <v-btn icon title="Listado UUID" @click="dialog1 = !dialog1; tipo_reporte_seleccionado=4;" v-tippy>
                                                <v-icon colorHover="secondary" size="48">mdi-clipboard-list-outline</v-icon>
                                            </v-btn>
                                        </v-col>
                                        <v-col sm="12" md="2" lg="2">
                                             <v-btn rounded color="primary" @click="generar_expediente_descarga()" :loading="loadingReporte">
                                                <v-icon>compress</v-icon> Generar Expediente
                                            </v-btn>
                                          </v-col>
                                          <v-col sm="12" md="2" lg="2">
                                             &nbsp;
                                          </v-col>
                                    </v-row>
                                    <v-row row wrap v-if="['Ingreso','Egreso'].includes(model.tipo_comprobante)">
                                        <v-col sm="12" md="6" lg="6">
                                            <v-text-field :label="model.tipo_comprobante=='Ingreso'?'Filtrar por RFC Receptor':'Filtrar por RFC Emisor'" v-model='model.rfc_filtro' clearable 
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                </v-container>
                            </v-form>
                            <v-card>
                                <v-card-text>

                                    <v-refresh-button :funcion="cargarExpedientes" />
                                    <v-client-table ref="vuetable" :data="datos_expediente" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                        <template slot="noResults" >
                                            <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                        </template>

                                        <template slot="actions" slot-scope="props" >
                                            <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadReporte(props.row.filename)" >
                                                <v-icon dark>get_app</v-icon>
                                            </v-btn>
                                            <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                                                <v-icon dark>delete</v-icon>
                                            </v-btn>
                                        </template>
                                    </v-client-table>
                                </v-card-text>
                            </v-card>
                        </v-card-text>
                    </v-tab-item>
                </v-tabs>

            </base-material-card>
        </v-flex>

    </v-container>
    <v-dialog v-model="dialog1" max-width="500px">
        <v-card>
            <v-card-text>
                <h5>Ingrese lista de UUIDs</h5>
                <span>Uno por línea</span>
                <v-form ref="formListado" lazy-validation="">
                    <v-textarea outlined rows="12" v-model="model.lista_uuids" :rules="[rules.required, maxListaRule]"></v-textarea>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small @click="model.lista_uuids='';dialog1 = false">Cancelar</v-btn>
                <v-btn small color="primary" @click="generaReporteListado();">Buscar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <!-- Modal Factura Proforma -->
    <v-dialog v-model="modalProforma" width="65%" max-width="100%">
        <v-card>
            <v-card-title>
                <v-spacer></v-spacer>
                <v-card class="primary white--text titulomodal">
                    <v-icon class="white--text">receipt</v-icon>&nbsp;Factura Proforma
                </v-card>
            </v-card-title>

            <v-divider></v-divider>
            <v-card-text>

                    <v-container grid-list-md >
                        <v-layout wrap>
                            <v-flex xs12>
                                <div id="facturaProforma">
                                    <div style="text-align:center;font-size:12px;font-weight:bold;line-height:12px!important;">
                                        <span></span>
                                    </div><br>
                                    <div style="font-size:11px;">
                                        <table id="tablaGenerales" width="100%">
                                            <tr>
                                                <td width="49%">
                                                    <table>
                                                        <tr>
                                                            <th width="30%">RFC emisor:</th>
                                                            <td width="70%">{{model_proforma.RFC}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Nombre emisor:</th>
                                                            <td>{{model_proforma.Nombre}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Folio:</th>
                                                            <td>{{model_proforma.Folio}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>RFC receptor:</th>
                                                            <td>{{model_proforma[" RFC"]}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Nombre receptor:</th>
                                                            <td>{{model_proforma[" Nombre"]}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Uso CFDI:</th>
                                                            <td>{{model_proforma.UsoCFDI}}</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td width="2%"></td>
                                                <td width="49%">
                                                    <tr>
                                                        <th width="35%">Folio fiscal:</th>
                                                        <td width="65%">{{model_proforma["Folio Fiscal"]}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>No. de serie del CSD:</th>
                                                        <td>{{model_proforma["No Certificado"]}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Código postal, fecha y hora de emisión:</th>
                                                        <td>{{model_proforma["Lugar de Expedicion"]}} {{model_proforma["Fecha"]}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Efecto de comprobante:</th>
                                                        <td>{{model_proforma["Tipo de Comprobante"]}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Régimen fiscal:</th>
                                                        <td>{{model_proforma["Regimen Fiscal"]}}</td>
                                                    </tr>
                                                </td>
                                            </tr>
                                        </table>
                                        <br/>
                                        <span style="font-weight:bold;font-size:12px;">Conceptos</span>
                                        <br><br>
                                        <table id="tablaMercancias" border=1>
                                            <tr style="text-align:center;background-color:#DCDBDA;">
                                                <th width="10%">Clave del producto y/o servicio</th>
                                                <th width="10%">No. identificación</th>
                                                <th width="9%">Cantidad</th>
                                                <th width="8%">Clave de unidad</th>
                                                <th width="10%">Unidad</th>
                                                <th width="10%">Valor unitario</th>
                                                <th width="10%">Importe</th>
                                                <th width="10%">Descuento</th>
                                                <th width="11%">No. de pedimento</th>
                                                <th width="11%">No. de cuenta predial</th>
                                            </tr>
                                            <template v-for="(concepto) in model_proforma.conceptos">
                                                <tr>
                                                    <td>{{concepto["Clave Prod Serv"]}}</td>
                                                    <td>{{concepto["No Identificacion"]}}</td>
                                                    <td>{{formatNumber(concepto["Cantidad"],2)}}</td>
                                                    <td>{{concepto["Clave Unidad"]}}</td>
                                                    <td>{{concepto["Unidad"]}}</td>
                                                    <td>{{formatNumber(concepto["Valor Unitario"],2)}}</td>
                                                    <td>{{formatNumber(concepto["Subtotal"],2)}}</td>
                                                    <td></td>
                                                    <td>{{concepto["Pedimento"]}}</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <th style="text-align:center;background-color:#DCDBDA;">Descripción</th>
                                                    <td colspan=4 style="vertical-align:middle !important; text-align:left !important;">{{concepto["Descripcion"]}}</td>
                                                    <td colspan=5>
                                                        <table id="TablaImpuestos" width="100%">
                                                            <tr>
                                                                <th>Impuesto</th>
                                                                <th>Tipo</th>
                                                                <th>Base</th>
                                                                <th>Tipo Factor</th>
                                                                <th>Tasa o Cuota</th>
                                                                <th>Importe</th>
                                                            </tr>
                                                            <tr v-if="concepto['Impuesto Traslado']!=''">
                                                                <td>{{concepto["Impuesto Traslado"]}}</td>
                                                                <td>Traslado</td>
                                                                <td>{{formatNumber(concepto["Subtotal"],2)}}</td>
                                                                <td>{{concepto["Tipo Factor Traslado"]}}</td>
                                                                <td>{{ concepto["TasaOCuota Traslado"]>0 ? formatNumber(concepto["TasaOCuota Traslado"]*100,4):concepto["TasaOCuota Traslado"]}}%</td>
                                                                <td style="text-align:right !important;">{{formatNumber(concepto["Importe Traslado"],2)}}</td>
                                                            </tr>
                                                            <tr v-if="concepto['Impuesto Retencion']!=''">
                                                                <td>{{concepto["Impuesto Retencion"]}}</td>
                                                                <td>Retencion</td>
                                                                <td>{{formatNumber(concepto["Subtotal"],2)}}</td>
                                                                <td>{{concepto["Tipo Factor Retencion"]}}</td>
                                                                <td>{{ concepto["TasaOCuota Retencion"]>0 ? formatNumber(concepto["TasaOCuota Retencion"]*100,4):concepto["TasaOCuota Retencion"]}}%</td>
                                                                <td style="text-align:right !important;">{{formatNumber(concepto["Importe Retencion"],2)}}</td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </template>

                                        </table>
                                        <br>
                                        <table id="tablaSubtotales" width="100%">
                                            <tr>
                                                <td width="51%">
                                                    <table width="100%">
                                                        <tr>
                                                            <th width="30%">Moneda:</th>
                                                            <td width="70%">{{model_proforma.Moneda}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Forma de pago:</th>
                                                            <td>{{model_proforma["Forma Pago"]}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Método de pago:</th>
                                                            <td>{{model_proforma["Metodo Pago"]}}</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td width="1%"></td>
                                                <td width="48%">
                                                    <table width="100%">
                                                        <tr>
                                                            <th width="40%">Subtotal:</th>
                                                            <td width="10%">&nbsp;</td>
                                                            <td width="15%">&nbsp;</td>
                                                            <td width="35%" style="text-align:right !important;">$ {{formatNumber(model_proforma["SumatoriaSubtotal"],2)}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Impuestos trasladados</th>
                                                            <td>{{model_proforma["NombreImpuestoTraslado"]}}</td>
                                                            <td style="text-align:right !important;">{{ model_proforma["TasaImpuestoTraslado"]>0 ? formatNumber(model_proforma["TasaImpuestoTraslado"]*100,4):model_proforma["TasaImpuestoTraslado"]}}%</td>
                                                            <td style="text-align:right !important;">$ {{formatNumber(model_proforma["Total Impuestos Trasladado"],2)}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Impuestos Retenido</th>
                                                            <td>{{model_proforma["NombreImpuestoRetenido"]}}</td>
                                                            <td></td>
                                                            <td style="text-align:right !important;">$ {{formatNumber(model_proforma["Total Impuestos Retenidos"],2)}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Total</th>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td style="font-weight:bold;text-align:right !important;">$ {{formatNumber(model_proforma["Total Facturado"],2)}}</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                        <br>
                                            <a :href="model_proforma.QRText" target="_blank" ><v-img v-if="qrSrc" :src="qrSrc" aspect-ratio="2" width="150px" height="150px" ></v-img></a>
                                        <br/>
                                    </div>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-container>

            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modalProforma=false">
                    <v-icon>cancel</v-icon>&nbsp;Cerrar
                </v-btn>
                <v-btn :loading="loadingBtn" color="success" @click.native="descargarFacturaProforma()">
                    <v-icon>picture_as_pdf</v-icon>&nbsp;Descargar PDF
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import axios from "axios";
import html2pdf from "html2pdf.js";
import moment from "moment";
import qrCode from 'qrcode';
import Vue from "vue";
import RefreshButton from "@/components/RefreshButton.vue";

export default {
    components: {
        "v-refresh-button": RefreshButton,
    },
    created: function () {
        this.URL = this.$hostname + "reportes/";
        this.loading = false;
        this.model.usuario = this.$local_storage.get("id_usuario");
        this.model.rfc = this.$local_storage.get("rfc");
        var tipoUsuario = this.$local_storage.get("tipo_usuario");
        if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario")
            this.permisoEliminar = true;
        
        if(this.$local_storage.get("trafico") == 1){
            this.breadcrumbs = [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home",
                },
                {
                    text: "E-Drive",
                    disabled: true,
                    to: ""
                },
                {
                    text: "Facturas en Tránsito",
                    disabled: true,
                    to: "",
                },
            ];
        }
        if(this.view_sa24 == 1){
            this.breadcrumbs = [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home",
                },
                {
                    text: "Solución A24",
                    disabled: true,
                    to: ""
                },
                {
                    text: "Facturas en Tránsito",
                    disabled: true,
                    to: "",
                },
            ];
        }
        this.cargarReportesDS();
        this.cargarReportesComercio();
        this.cargarExpedientes();
        this.getTiposDocumentos();

        var f = new Date();
         var f_de = new Date();

              f_de.setDate(f_de.getDate() + 1);



                let y_de = f_de.getFullYear();
                let m_de = f_de.getMonth() + 1;
                let d_de = f_de.getDate();

                if (m_de < 10)
                    m_de = '0' + m_de;
                if (d_de < 10)
                    d_de = '0' + d_de;

                let y = f.getFullYear();
                let m = f.getMonth() + 1;
                let d = f.getDate();


                if (m < 10)
                    m = '0' + m;
                if (d < 10)
                    d = '0' + d;


                this.model.fecha_de = y + "-" + m + "-" + d;
                this.model.fecha_a = y_de + "-" + m_de + "-" + d_de;
    },
    filters: {
        uppercase: function(value) {
            if (!value) return ''
            value = value.toString()
            return value.toUpperCase()
        },
    },
    data: () => ({
        tipo_reporte_seleccionado:0,
        ultima_opcion:0,
        permisoEliminar: false,
        tab: null,
        qrSrc: null,
        data_table_impo: [],
        lista_filtrada: [],
        lista_filtrada_uuids:[],
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home",
            },
            {
                text: "eCosting",
                disabled: true,
                to: ""
            },
            {
                text: "Facturas en Tránsito",
                disabled: true,
                to: "",
            },
        ],

        update: false,

        file: "",
        cliente: "",
        name_file: "",
        size_file: 0,
        type_file: 'application/zip',
        loadingBtn:false,
        modalProforma: false,
        model_proforma: {
            transportista:'',
            hbl:'',
            contenedor:'',
            facturas:'',
            agente_carga:'',
        },

        to_download: [],
        dialog1: false,
        dialog2: false,
        listado: "",
        datos: [],
        datos_comercio: [],
        datos_expediente: [],
        allChecked: false,
        columns: [
            "id",
            "fecha_solicitud",
            "usuario_email",
            "nombre_reporte",
            "criterio",
            "fecha_generacion",
            "estatus",
            "error",
            "actions",
        ],
        options: {
            filterable: [
                "id",
                "fecha_solicitud",
                "usuario_email",
                "nombre_reporte",
                "criterio",
                "fecha_generacion",
                "estatus",
                "error",
            ],
            sortable: [
                "id",
                "fecha_solicitud",
                "usuario_email",
                "nombre_reporte",
                "criterio",
                "fecha_generacion",
                "estatus",
                "error",
            ],

            headings: {
                id: "No. Proceso",
                fecha_solicitud: "Solicitado",
                usuario_email: "Usuario",
                nombre_reporte: "Reporte",
                criterio: "Criterio de Búsqueda",
                fecha_generacion: "Generado",
                estatus: "Estatus",
                error: "Error",
                actions: "Descargar",
            },
        },
        loading: true,
        loadingReporte: false,
        show_loading: true,
        tiposComprobante:[{"nombre":"Ingreso"},{"nombre":"Egreso"},
            {"nombre":"Traslado"},{"nombre":"Nómina"},{"nombre":"Pago"}
        ],
        model: {
            rfc: "",
            rfc_filtro: "",
            usuario: "",
            pedimento: "",
            fecha_de: "",
            fecha_a: "",
            tipo_comprobante:"",
            reporte_url: "/reportes_ws/consulta_adjuntos/",
            nombre_reporte: "Facturas en Tránsito",
            tipo: "Facturas Transito",
            tipo_reporte: "",
            archivo: "", //para buscar por nombre de adjunto
            integrado: -1, //Para que salgan integradas al expediente y las que todavia no
            lista_uuids:"",
            fecha_factura: false,
        },
        menu1: false,
        menu2: false,
        menu10: false,
        menu20: false,
        menu3: false,
        menu4: false,
        menu5: false,
        menu6: false,        
        tiposDocumentos: [],
        rules: {
            required: (v) => !!v || "Este campo es requerido",
            numeric: (value) => {
                const pattern = /^[\d]*$/;
                return pattern.test(value) || "Solo se permiten números";
            },
        },

        modal: false,
        data_resumen: [],
        data_resumen_excel: {
            Fecha: "fecha",
            Usuario: "nombre_usuario",
            Archivo: "filename",
            RFC: "rfc_factura",
            "Razon Social": "razon_social",
            Folio: "folio",
            "Fecha Emisión": "fecha_emision",
            "Tipo CFDI":"tipo_cfdi",
            "Importe":"importe",
            Metadato: "metadato",
            "Tipo Documento": "tipo_documento",

        },
        columns_resumen: [
            //"id",
            "fecha",
            "iniciales",
            "filename_original",
            "rfc_factura",
            "num_regtrib",
            "folio",
            "fecha_emision",
            "tipo_cfdi",
            "importe",
            "metadato",
            "tipo_documento",
            // "no_pedimento",
            // "existe",
            "actions_view"
        ],
        options_resumen: {
            filterable: [
                "fecha",
                "iniciales",
                "filename_original",
                "rfc_factura",
                "folio",
                "fecha_emision",
                 "tipo_cfdi",
                "importe",
                "metadato",
                // "tipo_documento",
                // "no_pedimento",
           // "existe",
            ],
            orderBy: {
                column: 'fecha',
                ascending: false
            },
            sortable: [
                "fecha",
                "iniciales",
                "filename_original",
                "rfc_factura",
                "folio",
                "fecha_emision",
                "tipo_cfdi",
                "importe",
                "metadato",
                // "tipo_documento",
                // "no_pedimento",
                //   "existe",
            ],
            headings: {
                id: "",
                fecha: "Fecha",
                iniciales: "Usuario",
                filename_original: "Archivo",
                rfc_factura: "RFC",
                "num_regtrib":"Num Reg Id Trib",
                descripcion: "Tipo de Documento",
                folio: "Folio",
                fecha_emision: "Fecha Emision",
                "tipo_cfdi":"Tipo CFDI",
                "importe":"Importe",
                metadato: "Metadato",
                tipo_documento: "Tipo Documento",
                //  no_pedimento: "No. Pedimento",
                // existe: "Existe",
                actions_view: 'Opciones'
            },
        },
    }),
    computed: {
        view_sa24() {
            return this.$store.state.sa24;
        },
    datafiltered() {                
            if (this.$refs.vuetabledetalle != null) {
                return this.$refs.vuetabledetalle.allFilteredData;                
            } else {               
                return this.data_resumen;
            }            
        },
    },
    methods: {
        cargarReportesDS: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.model.rfc,
                "tipo": "Facturas_Transito_SinPedimento"
            };
            if(this.view_sa24 == 1){//Solicitaron que para Solucion24 el reporte tenga otros encabezados
                data["tipo"] = "Facturas_Transito_SinPedimento_SA24";
            }
            axios.post(this.URL + "get_reportes/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datos = res.data;
                        this.datos.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud) ;
                        });
                        for (var k in this.datos) {
                            this.datos[k].fecha_solicitud = this.parseDate(this.datos[k].fecha_solicitud);
                            this.datos[k].fecha_generacion = this.parseDate(this.datos[k].fecha_generacion);
                            this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
                            this.datos[k].criterio = this.getCriterioPredeterminadosDS(this.datos[k].criterio);
                        }
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los reportes ds.",
                        footer: ""
                    });
                    console.log(err);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        cargarReportesComercio: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.model.rfc,
                "tipo": "Facturas_Comercio_Exterior"
            };
            axios.post(this.URL + "get_reportes/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datos_comercio = res.data;
                        this.datos_comercio.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud) ;
                        });
                        for (var k in this.datos_comercio) {
                            this.datos_comercio[k].fecha_solicitud = this.parseDate(this.datos_comercio[k].fecha_solicitud);
                            this.datos_comercio[k].fecha_generacion = this.parseDate(this.datos_comercio[k].fecha_generacion);
                            this.datos_comercio[k].estatus = this.getEstatus(this.datos_comercio[k].estatus);
                            this.datos_comercio[k].criterio = this.getCriterioPredeterminadosDS(this.datos_comercio[k].criterio);
                        }
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los reportes ds.",
                        footer: ""
                    });
                    console.log(err);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        cargarExpedientes: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.model.rfc,
                "tipo": "Facturas_Expediente_Descarga"
            };
            axios.post(this.URL + "get_reportes/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datos_expediente = res.data;
                        this.datos_expediente.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud) ;
                        });
                        for (var k in this.datos_expediente) {
                            this.datos_expediente[k].fecha_solicitud = this.parseDate(this.datos_expediente[k].fecha_solicitud);
                            this.datos_expediente[k].fecha_generacion = this.parseDate(this.datos_expediente[k].fecha_generacion);
                            this.datos_expediente[k].estatus = this.getEstatus(this.datos_expediente[k].estatus);
                            this.datos_expediente[k].criterio = this.getCriterioPredeterminadosDS(this.datos_expediente[k].criterio);
                        }
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los reportes ds.",
                        footer: ""
                    });
                    console.log(err);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        getCriterioPredeterminadosDS: function (criterio) {
            try {
                if (criterio != undefined && criterio.toString().trim() != "") {
                    var params = JSON.parse(criterio);
                    if(params.lista_uuids!=null && params.lista_uuids!="" && params.lista_uuids.length>0){
                        return "Búsqueda por listado";
                    } else {
                        if (params.tipo_reporte== undefined && params.fecha_de!=undefined ){
                            return "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;
                        } else if (params.tipo_reporte == 1) {
                            return "Pedimento: " + params.pedimento;
                        } else if (params.tipo_reporte == 3) {
                            return "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;
                        } else if (params.tipo_reporte == 4) {
                            return "Búsqueda por listado de pedimentos";
                        }
                    }
                    
                } else {
                    return "N/A";
                }
            } catch (error) {
                console.log(error);
                return "N/A-error";
            }

        },
        createObjectUrl(err, canvas) {
            if (!err) {
                canvas.toBlob((blob) => {
                    this.qrSrc = window.URL.createObjectURL(blob)
                })
            } else {
                console.warn('generateQrCode:ERROR', err)
            }
        },
        pickFile() {
            this.$refs.file_input.click()
        },
        onFilePicked(e) {
            try {
                const files = e.target.files;

                if (files[0] !== undefined) {

                    this.name_file = files[0].name;
                    this.size_file = files[0].size;
                    this.type_file = files[0].type;

                    if (this.size_file > 1000 * 1000 * 10) {
                        this.$swal({
                            type: "warning",
                            title: "¡Operación no Permitida!",
                            text: "El archivo no debe ser mayor a 10MB.",
                        });
                        this.reset();
                        return false;
                    }

                    var nombre = this.name_file.split(".");
                    var split = [];
                    var valido = false;

                    if (nombre.length == 2 && nombre[0] == 'facturas_en_transito') {
                        valido = true;
                    }

                    if (valido == false) {
                        this.reset();
                        this.$swal({
                            type: "warning",
                            title: "Favor de verificar",
                            text: "El archivo ZIP debe tener el nombre correcto facturas_en_transito.zip.",
                            footer: ""
                        });
                    } else {

                        /*Se cambio para que lo suba directo a SE y ya luego lo lea en la lambda*/
                        this.uploadFile(files[0], nombre[0]);

                        /*var thisObj = this;
                        const fr = new FileReader()
                        fr.readAsDataURL(files[0])

                        fr.addEventListener('load', () => {
                            this.file = fr.result; // this is an image file that can be sent to server...
                            var n = this.file.search("base64,");
                            //Para dejar solo el archivo en base 64 y quitar laparte de "application/zip; base64,"

                            if (n >= 0) {
                                this.file = this.file.substring(n + 7);
                            }
                            //console.log(this.file);
                            this.submitFile(nombre[0]);

                        });*/

                    }

                }
            } catch (error) {
                console.log(error);
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al leer el archivo. Favor de verificar que el archivo no esté dañado.",
                    footer: ""
                });
                this.reset();
            }

        },

        uploadFile: function (file, referencia) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var rfc_file = this.$local_storage.get("rfc");
            var usuario_file = this.$local_storage.get("id_usuario");

            var keyFile = "bandeja_entrada/" + rfc_file + "/" + usuario_file + "/" + this.name_file;
            var thisObj = this;
            var datos = {
                key: keyFile,
                bucket: "production.econnect.ds",
                type: this.type_file
            }
            axios.post(this.$hostname + 's3/upload_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var urlput = res.data.mensaje;
                        //console.log(urlput);
                        axios.put(urlput, file, {
                                headers: {
                                    'Content-Type': this.type_file
                                }
                            })
                            .then((res) => {
                                thisObj.submitFile(referencia, keyFile);
                            })
                            .catch((error) => {
                                this.$root.$dialogLoader.hide();
                                this.$swal({
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                                    footer: '',
                                });
                                console.log(error);
                            });

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al cargar el archivo. Favor de comunicarse con soporte.";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                    this.$root.$dialogLoader.hide();
                });
        },

        submitFile(referencia, keyFile) {
            let formData = {
                key: keyFile,
                filename: this.name_file,
                tipo: 'facturas_en_transito', //Por default
                referencia: this.$local_storage.get("rfc") + "-" + referencia,
                user_updated: this.$local_storage.get("email"),
                usuario: this.$local_storage.get("id_usuario"),
            };

            axios.post(this.$hostname + 'leexml/', formData)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {

                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "El archivo se está procesando, recibirá una notificación cuando termine.",
                            footer: '',
                        });
                    }

                })
                .catch((error) => {
                    var msg = ''
                    var mostrar = true;
                    if (error.response != null) {
                        if (error.response.data.mensaje != null)
                            msg = error.response.data.mensaje[0];
                        if (error.response.data.message != null) { //Si entra aqui significa que regreso un TimeOut de Amazon Api, recibirá notificacion cuando temrine
                            mostrar = false;
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "El archivo se está procesando, recibirá una notificación cuando termine.",
                                footer: '',
                            });
                            msg = error.response.data.message;
                        }
                    }
                    if (mostrar) {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al cargar el archivo",
                            footer: msg,
                        });
                        console.log(error);
                    }

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.reset();
                });

        },
        formatNumber: function(numero, decimales){
            if (numero == undefined || numero == null || numero == "")
                return ""
            return (numero).toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        },
        verFacturaProforma: function(rfc, filename){
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            var rfc = this.$local_storage.get("rfc");
            var datos = {
                archivo: filename,
                rfc: rfc
            };

            axios.post(this.$hostname + "reportes_ws/get_data_facturas_pedimentos/", datos)
            .then(response => {
                this.model_proforma = response.data;
                window.URL.revokeObjectURL(this.qrSrc)
                qrCode.toCanvas(this.model_proforma.QRText, {}, this.createObjectUrl)
                this.modalProforma = true;
            })
            .catch(error => {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener los datos de la factura.",
                    footer: ""
                });
            }).then(() => {
                this.$root.$dialogLoader.hide();
            });

        },
        descargarFacturaProformaMETODOANTERIOR: function(){
            this.loadingBtn = true;
            var opt = {
                margin: [0.5, 0.1, 0.5, 0.1], //top, left, bottom, right
                //filename: "Factura_Proforma_"+this.model_proforma.facturas.factura+".pdf",
                filename: this.model_proforma["Folio Fiscal"]+".pdf",
                image: {
                    type: "jpeg",
                    quality: 1
                },
                html2canvas: {
                    scale: 2
                },
                pagebreak: {
                    mode: [ "css", "legacy"]
                },
                jsPDF: {
                    unit: "in",
                    format: "letter",
                    orientation: "portrait", //portrait, landscape
                    compress: false,
                }
            };

            var html = document.getElementById("facturaProforma");
            var thisObj = this;
            html2pdf()
                .set(opt)
                .from(html)
                .save()
                .then(function (pdf2) {
                                    thisObj.loadingBtn = false;
                                })
        },
        downloadProforma: function(key_pdf){
            var datoss3 = {
                id: key_pdf,
                bucket: "facturas.abiertas.econectpro.mx"
            }
            var thisObj = this;
            axios.post(this.$hostname + 's3/download_url/', datoss3)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = '_blank';
                        a.click();
                        a.parentNode.removeChild(a);
                        this.$root.$dialogLoader.hide();
                    } else {                        
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al generar PDF. Favor de intentar nuevamente.",
                            footer: '',
                        });
                        this.$root.$dialogLoader.hide();                        
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo. Favor de intentar más tarde.";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                    this.$root.$dialogLoader.hide();
                    
                });
        },
        downloadFacturaProforma: function(filename, intento=0){
            var nombreZip = filename.toString()+".pdf";
            var key = this.$local_storage.get("rfc")+"/reportes/"+nombreZip;
            var datoss3 = {
                id: key,
                bucket: "production.econnect.ds"
            }

            var thisObj = this;
            axios.post(this.$hostname + 's3/download_url/', datoss3)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = '_blank';
                        a.click();
                        a.parentNode.removeChild(a);
                        this.$root.$dialogLoader.hide();
                    } else {
                        if(intento > 3) {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al generar PDF. Favor de intentar nuevamente.",
                                footer: '',
                            });
                            this.$root.$dialogLoader.hide();
                        } else {
                            setTimeout(function(){
                                thisObj.downloadFacturaProforma(filename, intento+1);
                            }, 10000); //Damos tiempo para generar el zip (10 seg)
                        }

                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo. Favor de intentar más tarde.";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;

                    if (mensaje.indexOf("El archivo no existe en S3")!=-1 && intento<=3){
                        setTimeout(function(){
                            thisObj.downloadFacturaProforma(filename, intento+1);
                        }, 10000); //Damos tiempo para generar el zip (10 seg)
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: mensaje,
                            footer: '',
                        });
                        console.log(error);
                        this.$root.$dialogLoader.hide();
                    }
                });

        },
        descargarFacturaProforma: function(){
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var filename = this.model_proforma["Folio Fiscal"];
            var datos = {
                rfc: this.$local_storage.get("rfc"),
                archivo: filename,
                reporte_url: "/reportes_ws/proforma_factura_transito/",
                nombre_reporte: "Proforma Factura en Transito",
                tipo: "Proforma_Factura_Transito",
                usuario: this.$local_storage.get("id_usuario"),
            };
            var thisObj = this;
            axios.post(this.$hostname + "reportes/save_reporte/", datos)
            .then(res => {
                setTimeout(function(){
                    thisObj.downloadFacturaProforma(filename, 1);
                }, 10000); //Damos tiempo para generar el zip (10 seg)
            })
            .catch(error => {
                if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined){
                    var mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                } else {//Si es un timeout intentamos descargar el archivo
                    setTimeout(function(){
                        thisObj.downloadFacturaProforma(filename, 1);
                    }, 10000); //Damos tiempo para generar el zip (10 seg)
                }
                console.log(error);
            });
        },
        reset() {
            const input = this.$refs.file_input;
            input.type = 'text';
            input.type = 'file';
            this.name_file = '';
        },
        validaFecha: function (fecha) {
            if (fecha == "Invalid date") return "Fecha no válida.";
            else return true;
        },
        validaAnio: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, "days");
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial.";
            }
            return true;
        },
        check_all: function () {
            let self = this;
            this.to_download = this.allChecked ?
                this.data_resumen.map((row) => self.model.rfc + "/" + row.folder + "/" + row.filename) : [];
        },
        validaDias: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, "days");
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial.";
                if (Math.abs(diferencia) > 365)
                    return "Periodo máximo de consulta 365 dias. Favor de verificar.";
            }
            return true;
        },

        validaLista: function () {
            if (this.model.fecha_de == "" && this.model.fecha_a == "") {
                if (this.model.lista != undefined && this.model.lista.length > 0)
                    return true
                else
                    return "La Fecha es requerida cuando no existe lista de ordenes de compra"
            }
            return true;
        },
        getCriterioPredeterminados: function (criterio) {
            try {
                if (criterio != undefined && criterio.toString().trim() != "") {
                    var params = JSON.parse(criterio);

                    let c = "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;

                    if (params.lista != undefined && params.lista.length > 0) {
                        c = " Orden: ";

                        params.lista.forEach(function (item) {
                            c += item + " | ";
                            console.log(item);
                        });
                    }

                    return c;

                } else {
                    return "N/A";
                }
            } catch (error) {
                return "N/A-error";
            }

        },
        getEstatus: function (estatus) {
            var arr_estatus = [
                "Pendiente",
                "Encolado",
                "Generado Correctamente",
                "Con Errores",
            ];
            if (estatus in arr_estatus) return arr_estatus[estatus];
            else return "N/A";
        },
        verificaRequeridos: function() {
            if (this.model.lista_uuids != '' && this.model.lista_uuids != null && this.model.lista_uuids.length > 0) {
                return true;
            }
            if (this.model.fecha_de == "" || this.model.fecha_a == "") {
                return "Favor de ingresar fechas o listado de UUIDs";
            }
            return true;
        },

        get_data_view: function (opcion = 0) {
            this.ultima_opcion = opcion;
            if (!this.$refs.form1.validate() && opcion == 0) {
                //Opción sirve para saltar la validación cuando se busca por listado
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                
                var data = Vue.util.extend({}, this.model);
                if(data["tipo_comprobante"]==null)
                    data["tipo_comprobante"]="";
                if(data["rfc_filtro"]==null)
                    data["rfc_filtro"]="";

                let selft = this;
                if (data.fecha_de == "") delete data["fecha_de"];
                if (data.fecha_a == "") delete data["fecha_a"];
                data.lista = [];
                if (data.lista_uuids == '' || data.lista_uuids == [] || opcion == 0) {//Si se busca por fechas, que ignore el listado
                    delete(data['lista_uuids']);                    
                } else {
                    data['lista_uuids'] = this.get_array_lista(data['lista_uuids']);   
                    //Si busca por lista que ignore el filtro de rfc
                    data['rfc_filtro'] = "";                 
                }                

                axios({
                        method: "post",
                        url: "https://apireportes.econnectpro.mx/reportes/facturas_abiertas_xml/",                        
                        data: data,
                    })
                    .then((res) => {

                        this.data_resumen = res.data;
                        this.data_resumen.forEach(function (r) {
                            r.fecha = r.fecha.substring(0, 10);

                            r.fecha_emision = r.fecha_emision.substring(0, 10);

                             if (r.folio == "" )
                                 r.folio = "No Localizado";

                            let a = r.filename.split("_");
                            let index_ = r.filename.indexOf("_"); //Por si el nombre del archivo tiene mas guiones bajos, solo separe el primero
                            r.filename_original = r.filename + "." + r.ext; //Se muestra el nombre original
                            r.filename = r.filename.substring(index_+1) + "." + r.ext; //Se suma 1 para quitar el guion bajo
                            r.folder = a[0];


                            if(r.tipo_documento != "No Localizado")
                              r.tipo_documento = r.tipo_documento + ' - '  + selft.getNombreTipoDocumento(r.tipo_documento);

                            if(r.tipo_documento == "null - ")
                                r.tipo_documento = "No Localizado";


                        });
                        //console.log(res.data);
                        //console.log(res.data.resumen);
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .then(() => {
                        this.$root.$dialogLoader.hide();
                    });
            }
        },

        download_files: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            var data = {
                rfc: this.model.rfc,
                usuario: this.model.usuario,
                pedimento: this.model.pedimento,
                fecha_de: this.model.fecha_de,
                fecha_a: this.model.fecha_a,
                lista: this.model.lista,
                reporte_url: "/reportes/facturas_abiertas_zip/",
                nombre_reporte: "Zip Facturas en Tránsito Seleccionadas",
                tipo: "Facturas Transito",
                tipo_reporte: 2,
                keys: this.to_download
            };

            if (data.pedimento == '') delete(data['pedimento']);
            if (data.archivo == '') delete(data['archivo']);
            if (data.fecha_de == '') delete(data['fecha_de']);
            if (data.fecha_a == '') delete(data['fecha_a']);
            if (data.lista == '' || data.lista == []) {
                delete(data['lista'])
            } else {
                if (data.tipo_reporte == 4) {
                    data['lista'] = this.get_array_lista(data['lista'])
                }
            }

            axios({
                    method: "post",
                    url: this.$hostname + "reportes/save_reporte/",
                    data: data
                })
                .then(response => {
                    this.to_download = [];
                    if (data.tipo_reporte == 4) {
                        this.model.lista = '';
                        this.lista_filtrada = [];
                    }
                    this.$swal({
                        type: "success",
                        title: "Operación Exitosa",
                        text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
                        footer: ""
                    });
                })
                .catch(error => {
                    let mensaje;
                    var titulo = "¡Operación no Permitida!";
                    var tipo = "error";
                    if (typeof error.response !== "undefined") {
                        mensaje = error.response.data.mensaje;
                        if (error.response.status == 406) {
                            titulo = "¡Ya existe un reporte en proceso!";
                            tipo = "info";
                        }
                    } else {
                        mensaje = "Ocurrió un error al generar el reporte";
                    }
                    this.$swal({
                        type: tipo,
                        title: titulo,
                        text: mensaje,
                        footer: ""
                    });
                }).then(() => {                    
                    this.$root.$dialogLoader.hide();
                });
        },
        get_array_lista: function (cadena) {
            let data = cadena.split("\n");
            let newarr = data.filter(a => a.trim() !== '');
            for (var i = 0; i < newarr.length; i++) {
                newarr[i] = newarr[i].trim().toUpperCase();
                newarr[i] = newarr[i].replace(',', '');
                newarr[i] = newarr[i].replace('.', '');
                let a = newarr[i].split("_");
            }

            return newarr;
        },
         generar_reporte_sqs(opcion = 0) {
            if (!this.$refs.formreporte.validate() && opcion == 0) {
                //Alguna operación o mensaje
            } else {

                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var data = {
                    rfc: this.model.rfc,
                    rfc_filtro: this.model.rfc_filtro==null?"":this.model.rfc_filtro,
                    usuario: this.model.usuario,
                    fecha_de: this.model.fecha_de,
                    fecha_a: this.model.fecha_a,
                    reporte_url: "/reportes_ws/facturas_adjuntas_pedimentos_transito/",
                    nombre_reporte: "Facturas en Tránsito",
                    tipo: "Facturas_Transito_SinPedimento",
                    fecha_factura: this.model.fecha_factura,
                    tipo_comprobante: this.model.tipo_comprobante==null?"":this.model.tipo_comprobante,
                    lista_uuids: this.model.lista_uuids
                };

                if (data.lista_uuids == '' || data.lista_uuids == [] || opcion == 0) {//Si se busca por fechas, que ignore el listado
                    delete(data['lista_uuids']);                    
                } else {
                    data['lista_uuids'] = this.get_array_lista(data['lista_uuids']);  
                    //Si busca por lista que ignore el filtro de rfc
                    data['rfc_filtro'] = "";
                }

                if(this.view_sa24 == 1){//(2025-03-04): Solicitaron que para Solucion24 el reporte detallado tenga otros encabezados
                    data["nombre_reporte"] = "Facturas en Tránsito SA24";
                    data["tipo"] = "Facturas_Transito_SinPedimento_SA24";
                    data["modulo_activo"] = "SA24";
                }

                axios({
                        method: "post",
                        url: this.$hostname + "reportes/save_reporte/",
                        data: data
                    })
                    .then(response => {

                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        let mensaje;
                        var titulo = "¡Operación no Permitida!";
                        var tipo = "error";
                        if (typeof error.response !== "undefined") {
                            mensaje = error.response.data.mensaje;
                            if (error.response.status == 406) {
                                titulo = "¡Ya existe un reporte en proceso!";
                                tipo = "info";
                            }
                        } else {
                            mensaje = "Ocurrió un error al generar el reporte";
                        }
                        this.$swal({
                            type: tipo,
                            title: titulo,
                            text: mensaje,
                            footer: ""
                        });
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.cargarReportesDS();
                    });
            }
        },
        generar_reporte_sqs_comercio(opcion=0) {
           if (!this.$refs.formreportecomercio.validate() && opcion==0) {
               //Alguna operación o mensaje
           } else {

               this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
               var data = {
                   rfc: this.model.rfc,
                   rfc_filtro: this.model.rfc_filtro==null?"":this.model.rfc_filtro,
                   usuario: this.model.usuario,
                   fecha_de: this.model.fecha_de,
                   fecha_a: this.model.fecha_a,
                   reporte_url: "/reportes_ws/facturas_comercio_exterior/",
                   nombre_reporte: "Facturas De Comercio Exterior",
                   tipo: "Facturas_Comercio_Exterior",
                   fecha_factura: this.model.fecha_factura,
                   tipo_comprobante: this.model.tipo_comprobante==null?"":this.model.tipo_comprobante,
                   lista_uuids: this.model.lista_uuids
               };

               if (data.lista_uuids == '' || data.lista_uuids == [] || opcion == 0) {//Si se busca por fechas, que ignore el listado
                    delete(data['lista_uuids']);                    
                } else {
                    data['lista_uuids'] = this.get_array_lista(data['lista_uuids']);  
                    //Si busca por lista que ignore el filtro de rfc
                    data['rfc_filtro'] = "";                  
                }
                
               axios({
                       method: "post",
                       url: this.$hostname + "reportes/save_reporte/",
                       data: data
                   })
                   .then(response => {

                       this.$swal({
                           type: "success",
                           title: "Operación Exitosa",
                           text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
                           footer: ""
                       });
                   })
                   .catch(error => {
                       let mensaje;
                       var titulo = "¡Operación no Permitida!";
                       var tipo = "error";
                       if (typeof error.response !== "undefined") {
                           mensaje = error.response.data.mensaje;
                           if (error.response.status == 406) {
                               titulo = "¡Ya existe un reporte en proceso!";
                               tipo = "info";
                           }
                       } else {
                           mensaje = "Ocurrió un error al generar el reporte";
                       }
                       this.$swal({
                           type: tipo,
                           title: titulo,
                           text: mensaje,
                           footer: ""
                       });
                   }).then(() => {
                       this.$root.$dialogLoader.hide();
                       this.cargarReportesComercio();
                   });
           }
       },
        generar_expediente_descarga(opcion=0) {
           if (!this.$refs.form_expediente.validate() && opcion==0) {
               //Alguna operación o mensaje
           } else {

               this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

               var data = Vue.util.extend({}, this.model);
                if(data["tipo_comprobante"]==null)
                    data["tipo_comprobante"]="";
                if(data["rfc_filtro"]==null)
                    data["rfc_filtro"]="";

                let self = this;
                if (data.fecha_de == "") delete data["fecha_de"];
                if (data.fecha_a == "") delete data["fecha_a"];
                data.lista = [];
                if (data.lista_uuids == '' || data.lista_uuids == [] || opcion == 0) {//Si se busca por fechas, que ignore el listado
                    delete(data['lista_uuids']);                    
                } else {
                    data['lista_uuids'] = this.get_array_lista(data['lista_uuids']);   
                    //Si busca por lista que ignore el filtro de rfc
                    data['rfc_filtro'] = "";                 
                }
                
                data.reporte_url = "/reportes_ws/facturas_abiertas_xml_descarga/";
                data.nombre_reporte = "Expediente de Facturas";
                data.tipo = "Facturas_Expediente_Descarga";
                delete data.tipo_reporte;

                console.log("DATA4: ", data);
                //this.$root.$dialogLoader.hide();
                //return false;

               axios({
                       method: "post",
                       url: this.$hostname + "reportes/save_reporte/",
                       data: data
                   })
                   .then(response => {

                       this.$swal({
                           type: "success",
                           title: "Operación Exitosa",
                           text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
                           footer: ""
                       });
                   })
                   .catch(error => {
                       let mensaje;
                       var titulo = "¡Operación no Permitida!";
                       var tipo = "error";
                       if (typeof error.response !== "undefined") {
                           mensaje = error.response.data.mensaje;
                           if (error.response.status == 406) {
                               titulo = "¡Ya existe un reporte en proceso!";
                               tipo = "info";
                           }
                       } else {
                           mensaje = "Ocurrió un error al generar el reporte";
                       }
                       this.$swal({
                           type: tipo,
                           title: titulo,
                           text: mensaje,
                           footer: ""
                       });
                   }).then(() => {
                       this.$root.$dialogLoader.hide();
                       this.cargarExpedientes();
                   });
           }
       },
        generaReporteListado() {
            if (this.$refs.formListado.validate()) {
                if(this.tipo_reporte_seleccionado == 1){
                    this.get_data_view(1);
                } else if(this.tipo_reporte_seleccionado == 2){
                    this.generar_reporte_sqs(1);
                } else if(this.tipo_reporte_seleccionado == 3){
                    this.generar_reporte_sqs_comercio(1);
                } else if(this.tipo_reporte_seleccionado == 4){
                    this.generar_expediente_descarga(1);
                }
                
                this.dialog1 = false;
                this.dialog2 = false;
            }
        },
        parseDate(date) {
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        parseDateTime(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
        },
        clear_values() {
            this.model.pedimento = "";
            this.model.fecha_de = "";
            this.model.fecha_a = "";
            this.model.archivo = "";
            this.listado = "";
        },
        base64ToArrayBuffer: function (base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        },
        downloadFile: function (row) {            
            let key = row.folder + '/' + row.folder + '_' + row.filename;
            let rfc = this.model.rfc;
            let file = rfc + "/" + key;
            
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            var datos = {
                id: file,
                bucket: "facturas.abiertas.econectpro.mx",
            };
            axios
                .post(this.$hostname + "s3/download_url/", datos)
                .then((res) => {
                    if (typeof res.data !== "undefined") {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        a.click();
                        a.parentNode.removeChild(a);
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: "",
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (
                        error.response != undefined &&
                        error.response.data != undefined &&
                        error.response.data.mensaje != undefined
                    )
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: "",
                    });
                    console.log(error);
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },

        downloadReporte: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = '_blank';
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        eliminarReporte: function (idreporte) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el reporte con No. Proceso: " +
                    idreporte +
                    "?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.value) {
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    var datos = {
                        id_reporte: idreporte,
                    };
                    axios
                        .post(this.$hostname + "reportes/eliminar_reporte/", datos)
                        .then((res) => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El reporte se eliminó correctamente",
                                footer: "",
                            });
                        })
                        .catch((error) => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                                footer: "",
                            });
                            console.log(error);
                        })
                        .then(() => {
                            this.$root.$dialogLoader.hide();
                            this.cargarReportesDS();
                            this.cargarReportesComercio();
                            this.cargarExpedientes();
                        });
                }
            });
        },
        setListValues: function () {
            this.lista_filtrada_uuids = [];
            let to_list = this.get_array_lista(this.model.lista_uuids);
            for (var i = 0; i < to_list.length; i++) {
                if (this.lista_filtrada_uuids.includes(to_list[i])) {
                    continue;
                } else {
                    this.lista_filtrada_uuids.push(to_list[i]);
                }
            }
            this.dialog1 = !this.dialog1;
        },
        maxListaRule: function () {
            if (this.model.lista_uuids == '' || this.model.lista_uuids == undefined || Array.isArray(this.model.lista_uuids)) {
                return "Lista vacia";
            }

            let x = this.model.lista_uuids.split("\n");

            if (x.length > 50) {
                return "No se puede consultar mas de 50 UUIDs";
            }

            return true;
        },
        getTiposDocumentos: function () {

            var data = {
                tabla: 25,
            };
            axios.post(this.$hostname + "apendices/lista/", data)
                .then(response => {
                    if (response.data != undefined) {
                        this.tiposDocumentos = response.data;
                        this.tiposDocumentos = this.tiposDocumentos.sort(function (a, b) {
                            return a.clave > b.clave;
                        });

                    }
                })
                .catch(error => {
                    console.log(error);
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los tipos de documento.",
                        footer: ""
                    });
                });
        },
        getNombreTipoDocumento: function (tipo) {
            var filtro = this.tiposDocumentos.filter(function (e) {
                return e.clave == tipo;
            });
            if (filtro.length > 0)
                return filtro[0].descripcion;
            else
                return '';
        },
        deleteFile: function (id_archivo) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el archivo ?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.value) {
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    var datos = {
                        id: id_archivo,
                    };
                    axios
                        .post(this.$hostname + "reportes/eliminar_factura_abierta_xml/", datos)
                        .then((res) => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El archivo se eliminó correctamente",
                                footer: "",
                            });
                        })
                        .catch((error) => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el archivo. Favor de comunicarse con soporte.",
                                footer: "",
                            });
                            console.log(error);
                        })
                        .then(() => {
                            this.$root.$dialogLoader.hide();
                            this.get_data_view(this.ultima_opcion);
                        });
                }
            });
        },
        async deleteFileAll(id_archivo) {

                    var datos = {
                        id: id_archivo,
                    };
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    await axios
                        .post(this.$hostname + "reportes/eliminar_factura_abierta_xml/", datos)
                        .then((res) => {
                             this.$root.$dialogLoader.hide();
                        })
                        .catch((error) => {

                            console.log(error);
                        });

        },
        deleteLista() {
            let self = this;
             this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar las facturas ?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
            }).then(async (result) => {
                if (result.value) {
                    self.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");                    
                    await Promise.all(self.datafiltered.map(async (r) => {
                        var datos = {
                            id: r.id,
                        };
                        
                        await axios
                            .post(self.$hostname + "reportes/eliminar_factura_abierta_xml/", datos)
                            .then((res) => {                                
                            }).catch((error) => {
                                console.log(error);                                
                            });
                    }));                    
                    self.$root.$dialogLoader.hide();
                    self.$swal({
                                type: "success",
                                title: "¡Operación Realizada!",
                                text: "Se elimináron los registros correctamente.",
                                footer: "",
                            }).then((result) => {
                        if (result.value) {
                            self.get_data_view(self.ultima_opcion);
                        }
                    });

                }
            });


        }
    },
};
</script>

<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
    color: black;
    font-size: small;
    background-color: #eeeeee;
    padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small;
    background-color: #df7205;
    padding: 0px;
    font-weight: bold;
}

.v-tabs-slider-wrapper {
    left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
    font-size: x-small !important;
}

#pdf {
    margin-left: 20px;
    height: auto;
    width: auto;
    font-family: Arial, sans-serif;
}
#facturaProforma {
    margin-left: 20px;
    height: auto;
    width: auto;
    font-family: Arial, sans-serif;
    /* font-weight: bold;    */
    line-height : 12px;
}
#tablaGenerales >>> th, td {
    border: 0 solid white !important;
    vertical-align: top !important;
    text-align: left !important;
}
#tablaMercancias tr td > #TablaImpuestos >>> th{
    border: 0 solid white !important;
    padding-right:2px !important;
    padding-left:2px !important;
    padding-top:1px !important;
    padding-bottom:1px !important;
}
#tablaMercancias tr td > #TablaImpuestos >>> td{
    border: 0 solid white !important;
    padding-right:2px !important;
    padding-left:2px !important;
    padding-top:1px !important;
    padding-bottom:1px !important;
}
#tablaMercancias >>> td {
    font-size: 8px;
    text-align: center !important;
    border: 0.1mm solid black !important;
    padding-right:3px !important;
    padding-left:3px !important;
    padding-top:1px !important;
    padding-bottom:1px !important;
}
#tablaMercancias >>> th {
    font-size: 8px;
    border: 0.1mm solid black !important;
    padding-right:3px !important;
    padding-left:3px !important;
    padding-top:3px !important;
    padding-bottom:3px !important;
}
</style>
